// extracted by mini-css-extract-plugin
export default {"link":"ViewFileLink_link__JdeAn"};